import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    notes: Yup.string()
      .required("This field is required")
      .nullable()
  }),
  mapPropsToValues: props => ({
    notes: props?.editedData ? props?.editedData?.discovery_queue?.note : ""
  }),

  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
